module.exports = __webpack_public_path__ + "static/historic4-528eae9d164635a5ad1da0ba062ad73f.jpg";